import React, {Component} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Card, CardBody, Col, Row} from "reactstrap";
import Parser from "react-html-parser";
import ListGroup from "reactstrap/es/ListGroup";
import ListGroupItem from "reactstrap/es/ListGroupItem";
import ListGroupItemHeading from "reactstrap/es/ListGroupItemHeading";
import Rate from "../../components/Rate";
import RegisterForm from "../Survey/components/RegisterForm";
import NextSurveys from "../Survey/components/NextSurveys";
import {isInteger} from "lodash";

class PageEnd extends Component {
  constructor() {
    super();

    this.getEndCashPoints_status3 = this.getEndCashPoints_status3.bind(this);
    this.getEndSocialPoints_status3 = this.getEndSocialPoints_status3.bind(this);

  }

  getEndCashPoints_status3(){
    if(this.props.surveyResponse.responseFrom === 'email'){
      if(isInteger(this.props.surveyResponse.collector.endCashPointsEmail)){
        return this.props.surveyResponse.collector.endCashPointsEmail
      }

      return this.props.survey.endCashPointsEmail;
    }

    if(isInteger(this.props.surveyResponse.collector.endCashPoints)){
      return this.props.surveyResponse.collector.endCashPoints
    }

    return this.props.survey.endCashPoints;
  }

  getEndSocialPoints_status3(){
    if(this.props.surveyResponse.responseFrom === 'email'){
      return this.props.survey.endSocialPointsEmail;
    }

    return this.props.survey.endSocialPoints;
  }

  getIframeAnalysisUrl(analysisOnEndScreenUid){
    return `//app.ankieteo.pl/analiza/${analysisOnEndScreenUid}/wykresy`
  }

  render() {
    const {surveyResponse, user, survey, nextSurveys} = this.props;
    const query = new URLSearchParams(location.search);
    const isMobileApp = !!query.get('mobileApp');
    let endingText = surveyResponse.endingText;
    if (!endingText) {
      endingText = surveyResponse.survey.endingScreens[0].content
    }

    return (
      <Card className={"ending-card"}>
        <CardBody className="ck-content ending-text">
          <div className="mb-5">{Parser(endingText)}</div>

          {(survey && survey.analysisOnEndScreenUid) && <iframe src={this.getIframeAnalysisUrl(survey.analysisOnEndScreenUid)} className="w-100 border-0" style={{ minHeight: '85vh' }} />}

          {!_.isEmpty(user) && <Row>
            <Col>
              {surveyResponse.status === 3 && <h1>Otrzymałeś/aś {this.getEndCashPoints_status3()} CashPoints oraz {this.getEndSocialPoints_status3()} SocialPoints!</h1>}
              {surveyResponse.status === 4 && <h1>Otrzymałeś/aś {survey.screenOutCashPoints} CashPoints oraz {survey.screenOutSocialPoints} SocialPoints!</h1>}
              <ListGroup className="mt-4">
                <ListGroupItemHeading tag="p">Aktualna liczba punktów na Twoim koncie</ListGroupItemHeading>
                <ListGroupItem>CashPoints: {user.pointTotal.find(t => t.type === 2).total}</ListGroupItem>
                <ListGroupItem>SocialPoints: {user.pointTotal.find(t => t.type === 1).total}</ListGroupItem>
              </ListGroup>
              {isMobileApp === false && <div>
                <a href={process.env.PANEL_HOST + "/logowanie"} style={{display: 'block', margin: '50px 0'}}>Przejdź do swojego konta w swpanel.pl</a>
              </div>}
              {isMobileApp === true && <div>
                <a href={"swpanel-app://logowanie"} style={{display: 'block', margin: '50px 0'}}>Przejdź do swojego konta w swpanel.pl</a>
              </div>}
            </Col>
          </Row>}

          {surveyResponse && !surveyResponse.endingText && surveyResponse.collector && surveyResponse.collector.type === 'Tokens' &&
            <ListGroup className="pb-5">
              <ListGroupItemHeading tag="p" className="text-center">Ta ankieta została już wypełniona z linka, z którego korzystasz.  </ListGroupItemHeading>
            </ListGroup>
          }

          {surveyResponse.isCollectorBaseSurveys && !surveyResponse.isRegisteredUser && <RegisterForm surveyResponse={surveyResponse} survey={this.props.survey}/>}

          {(surveyResponse.collector.hasOwnProperty('enabledRating') && surveyResponse.collector.enabledRating) && <Rate />}

          {nextSurveys && nextSurveys.length > 0 && <NextSurveys nextSurveys={nextSurveys}/>}
        </CardBody>
      </Card>
    );
  }
}

PageEnd.propTypes = {
  user: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    pointTotal: PropTypes.arrayOf(PropTypes.shape({
      total: PropTypes.number.isRequired,
      type: PropTypes.number.isRequired,
    }),),
  })]),
  survey: PropTypes.shape({
    endSocialPoints: PropTypes.number.isRequired,
    endCashPoints: PropTypes.number.isRequired,
    screenOutSocialPoints: PropTypes.number.isRequired,
    screenOutCashPoints: PropTypes.number.isRequired,
  }).isRequired,
  surveyResponse: PropTypes.shape({
    isCollectorBaseSurveys: PropTypes.bool.isRequired,
    isRegisteredUser: PropTypes.bool.isRequired,
    status: PropTypes.number.isRequired,
    rate: PropTypes.shape({
      rate: PropTypes.string,
    }),
    collector: PropTypes.shape({
      enabledRating: PropTypes.bool,
    }),
  }).isRequired,
  nextSurveys: PropTypes.arrayOf(PropTypes.shape({
    guid: PropTypes.string.isRequired,
    survey: PropTypes.shape({
      name: PropTypes.string.isRequired,
      endSocialPoints: PropTypes.number.isRequired,
      endCashPoints: PropTypes.number.isRequired,
    }).isRequired,
  })),
};

function mapStateToProps(state) {
  return {
    surveyResponse: state.surveyResponse,
    user: state.user,
    survey: state.surveyResponse.survey,
  }
}

export default connect(mapStateToProps)(PageEnd);
